//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VacansiaInfoModal",
  emits: ['openVakationModal'],

  methods: {
    openVakationModal() {
      this.$emit('openVakationModal');
    },
  },

  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
}
